/**
 * Bandeira de idioma — render via SVG inline (country-flag-icons)
 * pra funcionar igual em web + Capacitor (no APK, o flag-icons antigo
 * dependia de paths relativos via CSS background-image que falhavam
 * no file:// origin).
 *
 * `<Flag code="pt-BR" />` renderiza o SVG da bandeira do código de
 * idioma. Usado pelo trigger do dropdown e pelos items individuais.
 */
import { type LanguageCode } from '../i18n';
import BR from 'country-flag-icons/react/3x2/BR';
import US from 'country-flag-icons/react/3x2/US';
import ES from 'country-flag-icons/react/3x2/ES';
import FR from 'country-flag-icons/react/3x2/FR';

const flagComponents: Record<LanguageCode, React.ComponentType<{ className?: string; title?: string }>> = {
  'pt-BR': BR,
  en: US,
  es: ES,
  fr: FR,
};

const flagCodes: Record<LanguageCode, string> = {
  'pt-BR': 'br',
  en: 'us',
  es: 'es',
  fr: 'fr',
};

interface FlagProps {
  code: LanguageCode;
  className?: string;
}

export function Flag({ code, className = 'h-5 w-7 rounded-sm shadow-sm' }: FlagProps) {
  const FlagComp = flagComponents[code] || flagComponents['pt-BR'];
  return <FlagComp className={className} title={code} />;
}

export { flagCodes };
